import { LogOut } from "lucide-react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";

import { Brand } from "@/components/Brand.tsx";
import { DashboardPage } from "@/pages/DashboardPage.tsx";
import { LoginPage } from "@/pages/LoginPage.tsx";
import { TenantPage } from "@/pages/TenantPage.tsx";
import { useSession } from "@/stores/session.ts";

/** Solo con sesión completa (2FA configurado). */
function Protected() {
  const { token, requires2faSetup, clear } = useSession();
  if (!token || requires2faSetup) return <Navigate to="/login" replace />;
  return (
    <div className="min-h-screen">
      <header className="flex h-16 items-center justify-between border-b border-slate-200 bg-white px-6">
        <Brand caption="Consola de plataforma" />
        <button
          type="button"
          onClick={clear}
          className="flex items-center gap-1.5 rounded-xl border border-slate-200 px-3 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50"
        >
          <LogOut className="h-4 w-4" /> Salir
        </button>
      </header>
      <main className="mx-auto max-w-6xl p-6">
        <Outlet />
      </main>
    </div>
  );
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<Protected />}>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/tenants/:tenantId" element={<TenantPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
